import * as tabsEngine from './engines/tabs-engine.js';
import * as accordionEngine from './engines/accordion-engine.js';

/** @type {Record<string, typeof tabsEngine>} */
const engines = { tabs: tabsEngine, accordion: accordionEngine };

/**
 * Create a field section layout using the specified engine.
 *
 * @param {HTMLElement} container
 * @param {import('../../contracts/field-sections.js').FieldSectionLayoutConfig} config
 * @param {{ engine?: string }} [options]
 * @returns {import('../../contracts/field-sections.js').FieldSectionLayoutHandle}
 */
export function createFieldSectionLayout(container, config, options) {
  const engineName = options?.engine ?? 'tabs';
  const engine = engines[engineName];
  if (!engine) throw new Error(`Unknown field section engine: '${engineName}'`);
  return engine.mount(container, config);
}
